import { useTranslation } from "react-i18next";
import { cocoColorRange } from "../util/colors";
import { legendItemStyle, legendStyle } from "./style";

export const CocoLegend = ({ customLegendStyle = legendStyle, hazardName, companyName, version }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{`Commercial correction ${hazardName} ${companyName}`}</b>
      </div>
      <div>
        <span style={legendItemStyle(cocoColorRange[0])}></span>
        {t("levels.noData")}
      </div>
      <div>
        <span style={legendItemStyle(cocoColorRange[1])}></span>
        {t("levels.low")}
      </div>
      <div>
        <span style={legendItemStyle(cocoColorRange[2])}></span>
        {t("levels.moderate")}
      </div>

      <div>
        <span style={legendItemStyle(cocoColorRange[3])}></span>
        {t("levels.high")}
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t(`riskExposureMapExplained.${version}`)}
        </span>
      </div>
    </div>
  );
};
